export const commonDogBreeds = [
  'Mixed Breed',
  'Affenpinscher', 'Afghan Hound', 'Airedale Terrier', 'Akita', 'Alaskan Klee Kai',
  'Alaskan Malamute', 'American Bulldog', 'American English Coonhound',
  'American Eskimo Dog', 'American Foxhound', 'American Hairless Terrier',
  'American Leopard Hound', 'American Staffordshire Terrier', 'American Water Spaniel',
  'Anatolian Shepherd Dog', 'Appenzeller Sennenhund', 'Australian Cattle Dog',
  'Australian Kelpie', 'Australian Shepherd', 'Australian Stumpy Tail Cattle Dog',
  'Australian Terrier', 'Azawakh',
  'Barbado da Terceira', 'Barbet', 'Basenji', 'Basset Fauve de Bretagne',
  'Basset Hound', 'Bavarian Mountain Scent Hound', 'Beagle', 'Bearded Collie',
  'Beauceron', 'Bedlington Terrier', 'Belgian Laekenois', 'Belgian Malinois',
  'Belgian Sheepdog', 'Belgian Tervuren', 'Bergamasco Sheepdog', 'Berger Picard',
  'Bernese Mountain Dog', 'Bichon Frise', 'Biewer Terrier', 'Black and Tan Coonhound',
  'Black Russian Terrier', 'Bloodhound', 'Blue Picardy Spaniel', 'Bluetick Coonhound',
  'Boerboel', 'Bohemian Shepherd', 'Bolognese', 'Border Collie', 'Border Terrier',
  'Borzoi', 'Boston Terrier', 'Bouvier des Ardennes', 'Bouvier des Flandres',
  'Boxer', 'Boykin Spaniel', 'Bracco Italiano', 'Braque du Bourbonnais',
  'Braque Francais Pyrenean', 'Braque Saint-Germain', 'Brazilian Terrier',
  'Briard', 'Brittany', 'Broholmer', 'Brussels Griffon', 'Bull Terrier',
  'Bulldog', 'Bullmastiff',
  'Cairn Terrier', 'Calupoh', 'Canaan Dog', 'Canadian Eskimo Dog', 'Cane Corso',
  'Cardigan Welsh Corgi', 'Carolina Dog', 'Catahoula Leopard Dog',
  'Caucasian Shepherd Dog', 'Cavalier King Charles Spaniel',
  'Central Asian Shepherd Dog', 'Cesky Terrier', 'Chesapeake Bay Retriever',
  'Chihuahua', 'Chinese Crested', 'Chinese Shar-Pei', 'Chinook', 'Chow Chow',
  'Cirneco dell\'Etna', 'Clumber Spaniel', 'Cocker Spaniel', 'Collie',
  'Coton de Tulear', 'Croatian Sheepdog', 'Curly-Coated Retriever',
  'Czechoslovakian Vlciak',
  'Dachshund', 'Dalmatian', 'Dandie Dinmont Terrier', 'Danish-Swedish Farmdog',
  'Deutscher Wachtelhund', 'Doberman Pinscher', 'Dogo Argentino',
  'Dogue de Bordeaux', 'Drentsche Patrijshond', 'Drever', 'Dutch Shepherd',
  'English Cocker Spaniel', 'English Foxhound', 'English Setter',
  'English Springer Spaniel', 'English Toy Spaniel', 'Entlebucher Mountain Dog',
  'Estrela Mountain Dog', 'Eurasier',
  'Field Spaniel', 'Finnish Lapphund', 'Finnish Spitz', 'Flat-Coated Retriever',
  'French Bulldog', 'French Spaniel',
  'German Longhaired Pointer', 'German Pinscher', 'German Shepherd Dog',
  'German Shorthaired Pointer', 'German Spitz', 'German Wirehaired Pointer',
  'Giant Schnauzer', 'Glen of Imaal Terrier', 'Golden Retriever', 'Gordon Setter',
  'Grand Basset Griffon Vendeen', 'Great Dane', 'Great Pyrenees',
  'Greater Swiss Mountain Dog', 'Greyhound',
  'Hamiltonstovare', 'Hanoverian Scenthound', 'Harrier', 'Havanese',
  'Hokkaido', 'Hovawart',
  'Ibizan Hound', 'Icelandic Sheepdog', 'Irish Red and White Setter',
  'Irish Setter', 'Irish Terrier', 'Irish Water Spaniel', 'Irish Wolfhound',
  'Italian Greyhound',
  'Jagdterrier', 'Japanese Akitainu', 'Japanese Chin', 'Japanese Spitz',
  'Japanese Terrier',
  'Kai Ken', 'Karelian Bear Dog', 'Keeshond', 'Kerry Blue Terrier', 'Kishu Ken',
  'Komondor', 'Korean Jindo Dog', 'Kromfohrlander', 'Kuvasz',
  'Labrador Retriever', 'Lagotto Romagnolo', 'Lakeland Terrier',
  'Lancashire Heeler', 'Lapponian Herder', 'Large Munsterlander', 'Leonberger',
  'Lhasa Apso', 'Lowchen',
  'Maltese', 'Manchester Terrier (Standard)', 'Manchester Terrier (Toy)',
  'Mastiff', 'Miniature American Shepherd', 'Miniature Bull Terrier',
  'Miniature Pinscher', 'Miniature Schnauzer', 'Mountain Cur', 'Mudi',
  'Neapolitan Mastiff', 'Nederlandse Kooikerhondje', 'Newfoundland',
  'Norfolk Terrier', 'Norrbottenspets', 'Norwegian Buhund', 'Norwegian Elkhound',
  'Norwegian Lundehund', 'Norwich Terrier', 'Nova Scotia Duck Tolling Retriever',
  'Old English Sheepdog', 'Otterhound',
  'Papillon', 'Parson Russell Terrier', 'Pekingese', 'Pembroke Welsh Corgi',
  'Peruvian Inca Orchid', 'Petit Basset Griffon Vendeen', 'Pharaoh Hound',
  'Plott Hound', 'Pointer', 'Polish Lowland Sheepdog', 'Pomeranian',
  'Pont-Audemer Spaniel', 'Poodle (Miniature)', 'Poodle (Standard)',
  'Poodle (Toy)', 'Porcelaine', 'Portuguese Podengo',
  'Portuguese Podengo Pequeno', 'Portuguese Pointer', 'Portuguese Sheepdog',
  'Portuguese Water Dog', 'Presa Canario', 'Pudelpointer', 'Pug', 'Puli',
  'Pumi', 'Pyrenean Mastiff', 'Pyrenean Shepherd',
  'Rafeiro do Alentejo', 'Rat Terrier', 'Redbone Coonhound', 'Rhodesian Ridgeback',
  'Romanian Carpathian Shepherd', 'Romanian Mioritic Shepherd Dog', 'Rottweiler',
  'Russell Terrier', 'Russian Toy', 'Russian Tsvetnaya Bolonka',
  'Saint Bernard', 'Saluki', 'Samoyed', 'Schapendoes', 'Schipperke',
  'Scottish Deerhound', 'Scottish Terrier', 'Sealyham Terrier', 'Segugio Italiano',
  'Shetland Sheepdog', 'Shiba Inu', 'Shih Tzu', 'Shikoku Ken', 'Siberian Husky',
  'Silky Terrier', 'Skye Terrier', 'Sloughi', 'Slovakian Wirehaired Pointer',
  'Slovensky Cuvac', 'Slovensky Kopov', 'Small Munsterlander', 'Smooth Fox Terrier',
  'Soft Coated Wheaten Terrier', 'Spanish Mastiff', 'Spanish Water Dog',
  'Spinone Italiano', 'Stabyhoun', 'Staffordshire Bull Terrier',
  'Standard Schnauzer', 'Sussex Spaniel', 'Swedish Lapphund', 'Swedish Vallhund',
  'Taiwan Dog', 'Teddy Roosevelt Terrier', 'Thai Bangkaew', 'Thai Ridgeback',
  'Tibetan Mastiff', 'Tibetan Spaniel', 'Tibetan Terrier', 'Tornjak', 'Tosa',
  'Toy Fox Terrier', 'Transylvanian Hound', 'Treeing Tennessee Brindle',
  'Treeing Walker Coonhound',
  'Vizsla', 'Volpino Italiano',
  'Weimaraner', 'Welsh Springer Spaniel', 'Welsh Terrier',
  'West Highland White Terrier', 'Wetterhoun', 'Whippet', 'Wire Fox Terrier',
  'Wirehaired Pointing Griffon', 'Wirehaired Vizsla', 'Working Kelpie',
  'Xoloitzcuintli',
  'Yakutian Laika', 'Yorkshire Terrier',
  'Other'
];

export const commonCatBreeds = [
  'Domestic Shorthair', 'Domestic Longhair', 'Siamese', 'Persian',
  'Maine Coon', 'Ragdoll', 'British Shorthair', 'Abyssinian', 'Bengal',
  'Scottish Fold', 'Sphynx', 'Russian Blue', 'Birman'
];

export const breedsBySpecies = { dog: commonDogBreeds, cat: commonCatBreeds };
